import { Permission } from './permission.model';


export class Role {

    constructor(name?: string, description?: string, defaultRoleName?: string, permissions?: Permission[]) {

        this.Name = name;
        this.Description = description;
        this.DefaultRoleName = defaultRoleName;
        this.Permissions = permissions;
    }

    public Id: string;
    public Name: string;
    public IsVisibleToThirdParty: boolean;
    public Description: string;
    public DefaultRoleName: string;
    public usersCount: string;
    public Permissions: Permission[];
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/models/role.model.ts